import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { DefaultDialog } from '@/ui_v3';
import { NextQuizsetSelect } from '../modal/NextQuizsetSelect';
const overlayId = 'nextQuizsetSelectModal';
export const useOpenNextQuizsetSelectModal = () => {
  const {
    t
  } = useTranslation(['build']);
  return async ({
    excludeQuizsetIds
  }: {
    excludeQuizsetIds: string[];
  }) => {
    const quizsetId = await overlay.openAsync(({
      close
    }) => <DefaultDialog className="h-[720px] max-mobile-lg:h-[calc(90%-env(safe-area-inset-top))]" size="lg" onClose={close} header={{
      title: t('build:nextQuizModal.title'),
      hasCloseButton: true
    }} body={<NextQuizsetSelect excludeQuizsetIds={excludeQuizsetIds} onSelect={quizsetId => {
      close(quizsetId);
    }} />} />, {
      overlayId
    });
    overlay.unmount(overlayId);
    return quizsetId as string | boolean;
  };
};